import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { RawLines } from "../RawLines";

export const SubtotalLine = ({ preview, options }: ComponentLineProps) => {
  if (!preview.future_payments) {
    return null;
  }

  return <RawLines.SubtotalLine preview={preview} options={options} />;
};
